import { Logo } from '../../../shared/components/Logo';
import { ThemeToggle } from '../../../shared/components/ThemeToggle';

/**
 * Page chrome for the public (signed-out) merchant self-onboarding pages — PE-2097.
 *
 * ⚠️ Defined at module scope on purpose. Both SignUpPage and SignContractPage used to
 * declare this wrapper *inside* their component bodies, which gave it a fresh function
 * identity on every render. React compares element types by identity, so each keystroke
 * unmounted the entire form subtree and mounted a new one — the focused input was
 * destroyed mid-type, focus was lost and the browser scrolled back to the top (PE-2272
 * bug 1). On the contract page the same remount silently cleared the signature canvas.
 * Never move a component declaration inside another component's body.
 */
export const OnboardingShell = ({ children }: { children: React.ReactNode }) => (
  <div className="min-h-dvh bg-background text-foreground flex flex-col items-center px-4 py-10">
    <div className="absolute top-4 right-4">
      <ThemeToggle />
    </div>
    <div className="w-full max-w-2xl flex flex-col items-center">
      <Logo className="h-9 w-auto mb-8" />
      {children}
    </div>
  </div>
);
